import * as React from 'react';
import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';
import Skeleton from '@mui/material/Skeleton';


export const SkeletonLoader = $ => {
  return (
    <Grid container wrap="nowrap">
       <Box sx={{ width: 1 }}>
         {Array(8).fill(true).map((el, i)=>{
               return <div key={i}>
        <Skeleton key={i} variant="h1" animation="wave" />
              <br/>
              </div>

         })}
           
          
      </Box>
    </Grid>
  ); 
}

